// src/utils/tagUtils.js
// Shared tag helpers used across the Programs library page and the Program Builder.
// Tags are plain strings on a program's `tags` array; colors are DERIVED from the
// name (deterministic hash -> palette) so the same tag is the same color everywhere,
// with no separate tags collection to maintain.

// Number of evenly-spaced hue buckets around the color wheel. 36 gives visually
// distinct colors (10° apart) while keeping collisions rare for a realistic tag count.
const TAG_HUE_BUCKETS = 36;

// Deterministic color per tag name: FNV-1a hash -> one of TAG_HUE_BUCKETS evenly-spaced
// hues, rendered at fixed vivid saturation/lightness so every color is readable and
// distinct. Same tag = same color everywhere. Zero storage. Case-insensitive.
function tagHue(name) {
  const key = (name || '').toLowerCase();
  let h = 0x811c9dc5;
  for (let i = 0; i < key.length; i++) {
    h ^= key.charCodeAt(i);
    h = (h * 0x01000193) >>> 0;
  }
  const bucket = h % TAG_HUE_BUCKETS;
  return Math.round((bucket * 360) / TAG_HUE_BUCKETS);   // evenly spaced around the wheel
}

// Solid chip text/dot color for a tag.
export function tagColor(name) {
  return `hsl(${tagHue(name)}, 68%, 48%)`;
}

// Translucent chip background for a tag (same hue, low opacity). Use this instead of
// concatenating an alpha onto tagColor() — hsl()+'22' is invalid CSS.
export function tagBg(name) {
  return `hsla(${tagHue(name)}, 68%, 48%, 0.14)`;
}

// Max tags per program (cross-cutting attributes; folders carry hierarchy).
export const MAX_TAGS = 4;